module.exports = __webpack_public_path__ + "static/media/gameplay4.56ca63c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay4.png
// module id = 195
// module chunks = 0